<template>
  <div class="price">
    <div class="amount">
      <span v-if="showFromLabel">From </span>
      <span>{{ currencyFormat(discountedPrice || price, currency, true) }}</span>
    </div>

    <div v-if="discountedPrice && discountedPrice !== price" class="original">
      <span v-if="showFromLabel">From </span>
      <span>{{ currencyFormat(price, currency, true) }}</span>
    </div>

    <span>per person</span>
  </div>

  <div class="btn" v-html="reserveButtonHtml"></div>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { currencyFormat } from '@/utils/numberUtils.js'
import { onMounted, ref } from 'vue'
import { logErrorOnSentry } from '@/utils/errorReportingUtils.js'

const store = useItineraryStore()
const {
  price,
  currency,
  discountedPrice,
  data: { eventsCount, priceByPackageSequence },
  getReserveButtonHtml,
} = store
const reserveButtonHtml = ref('')

// The price is the first package in the admin's sequence, not the cheapest one,
// so "From" would understate it.
const showFromLabel = eventsCount > 1 && !priceByPackageSequence

onMounted(async () => {
  if (store.isProjectionPreview) return

  try {
    reserveButtonHtml.value = (await getReserveButtonHtml()) ?? ''
  } catch (error) {
    logErrorOnSentry(error, { component: 'ItineraryPriceAndCta', function: 'getReserveButtonHtml' })
  }
})
</script>

<style lang="scss" scoped>
.price {
  @include base-font;
  color: $grey-100;
  @include flex-column;
  align-items: center;
  gap: 6px;
}

.amount {
  color: $red-300;
  font-weight: 600;
  font-size: 18px;
}

.original {
  text-decoration: line-through;
}

.btn:deep(#reserve-btn) {
  @include base-font;
  color: white;
  border-radius: 1000px;
  margin-inline: auto;
}
</style>
